import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import {HttpService} from '../../../../../../core';
import {ToastrService} from 'ngx-toastr';


@Component({
  selector: 'app-link-package',
  templateUrl: './link-package.component.html',
  styleUrls: ['./link-package.component.scss']
})

export class LinkPackageComponent implements OnInit {
  displayedColumns: string[] = ['select', 'packageName', 'packagePrice', 'property'];
  dataSource = [];
  selection = new SelectionModel<any>(true, []);
  position = new SelectionModel<any>(true, []);

  existingPackages = [];
  allProperties: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.flattenProperties();
    console.log(this.data.project, 'packageProjects');
    // this.packageProperties = this.data.project.packageProjects.properties;
    // this.packageProperties = this.data.project.packageProjects;
    this.dataSource = this.allProperties;
    // console.log(this.packageProperties, 'packageProperties');
    // this.existingPackages = this.data.lot.packageProjects;
    // if (this.existingPackages) {
    //     this.existingPackages.forEach((p) => {
    //         const temp = this.dataSource.filter((packageP: any) => packageP.id === p.id);
    //         if (temp) {
    //             this.selection.select(temp[0]);
    //         }
    //     });
    // }

    // this.httpService.getAllPackageByCompany(this.data.projectId).subscribe((res: any) => {
    //   console.log(res, 'getAllPackageByCompany');
    //   if (res.code === 1) {
    //     this.flattenProperties();
    //     this.dataSource = res.data;
    //     // this.dataSource.push({property: this.allProperties});
    //     console.log(this.dataSource, 'dataSource:::::::');
    //     this.existingPackages = this.data.lot.packageProjects;
    //     if (this.existingPackages) {
    //       this.existingPackages.forEach((p) => {
    //         const temp = this.dataSource.filter((packageP: any) => packageP.id === p.id);
    //         console.log(temp);
    //         if (temp) {
    //           this.selection.select(temp[0]);
    //         }
    //       });
    //     }
    //   }
    // });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    // const numFormerselectedUsers = this.formerSelectedUsers.length;
    // console.log( numSelected === numRows || numFormerselectedUsers === numRows);
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    // console.log(this.selection.toggle(row));

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  confirm() {
    console.log(this.selection);
    const selectedId = [];
    this.selection.selected.map(user => {
      selectedId.push(user.id);
    });
    console.log(selectedId);
    const fd = new FormData();
    fd.append('packageProjectIds', selectedId.toString());
    this.httpService.updateLot(fd, this.data.lot.id).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('Package has been linked to this lot');
        this.dialogRef.close({packageProjects: res.data.packageProjects});
      } else {
        this.toastrService.error('Failed to link package with this lot');
      }
    });
  }

  /** Get properties arrays from packageProjects. */
  flattenProperties() {
    const packageProperties = this.data.project.packageProjects;
    this.allProperties = packageProperties.reduce((acc, currPackage) => {
      return acc.concat(currPackage.properties);
    }, []);
    console.log('properties:', this.allProperties);
  }
}
